import React, { useState } from "react";
import { PRIVACY_POLICY_DATA as privacyPolicyData } from "../../utils/privacyPolicyData";
import BreadCrumb from "../../components/BreadCrumb";

// Reusable AccordionSection Component
const AccordionSection = React.memo(({ title, isOpen, onClick, children }) => {
  return (
    <div className="border rounded-lg mb-4">
      <button
        onClick={onClick}
        className="w-full px-4 py-3 flex justify-between bg-gray-50 text-start rounded-t-lg hover:bg-gray-100"
      >
        <span className="text-[16px] md:text-[20px] font-semibold">
          {title}
        </span>
        <span className="transform transition-transform duration-200">
          {isOpen ? "−" : "+"}
        </span>
      </button>
      {isOpen && <div className="p-4 border-t">{children}</div>}
    </div>
  );
});

// Reusable SectionContent Component
const SectionContent = React.memo(({ data }) => {
  return (
    <div className="space-y-4">
      <div className="grid gap-4">
        {data.map((item, index) => (
          <div key={index} className="bg-white rounded-lg p-4 flex">
            <h4 className="font-semibold text-[#888888] flex flex-col gap-[15px]">
              {item.title}
            </h4>
          </div>
        ))}
      </div>
    </div>
  );
});

// Main PrivacyPolicyPage Component
const PrivacyPolicyPage = () => {
  const [openSections, setOpenSections] = useState({});

  const toggleSection = (section) => {
    setOpenSections((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };

  // Sections Data
  const sections = [
    // { key: "dataCollection", title: "WHAT INFORMATION DO WE COLLECT?", data: privacyPolicyData.dataCollection.personalData },
    // { key: "dataUsage", title: "HOW DO WE PROCESS YOUR INFORMATION?", data: privacyPolicyData.dataUsage.legalGrounds },
    // { key: "dataSharing", title: "WHEN AND WITH WHOM DO WE SHARE YOUR PERSONAL INFORMATION?", data: privacyPolicyData.dataSharing.parties },
    // { key: "userRights", title: "DO WE USE COOKIES AND OTHER TRACKING TECHNOLOGIES?", data: privacyPolicyData.userRights },
    // { key: "aiBased", title: "DO WE OFFER ARTIFICIAL INTELLIGENCE-BASED PRODUCTS?", data: privacyPolicyData.aiBased },
    // { key: "keepInfo", title: "HOW LONG DO WE KEEP YOUR INFORMATION?", data: privacyPolicyData.keepInfo },
    // { key: "infoSafe", title: "HOW DO WE KEEP YOUR INFORMATION SAFE?", data: privacyPolicyData.infoSafe },
    // { key: "privacyRights", title: "WHAT ARE YOUR PRIVACY RIGHTS?", data: privacyPolicyData.privacyRights },
    // { key: "notTrack", title: "CONTROLS FOR DO-NOT-TRACK FEATURES", data: privacyPolicyData.notTrack },
    // { key: "notice", title: "DO WE MAKE UPDATES TO THIS NOTICE?", data: privacyPolicyData.notice },
    // { key: "contactUs", title: "HOW CAN YOU CONTACT US ABOUT THIS NOTICE?", data: privacyPolicyData.contactUs },
    // { key: "crud", title: "HOW CAN YOU REVIEW, UPDATE, OR DELETE THE DATA WE COLLECT FROM YOU?", data: privacyPolicyData.crud },
    {
      key: "privacyRights",
      title: "No Data Collection",
      data: privacyPolicyData.privacyRights,
    },
    {
      key: "notTrack",
      title: "No Third-Party Sharing",
      data: privacyPolicyData.notTrack,
    },
    {
      key: "notice",
      title: "No Cookies or Tracking",
      data: privacyPolicyData.notice,
    },
    { key: "crud", title: "Security", data: privacyPolicyData.crud },
    {
      key: "contactUs",
      title: "Contact Us",
      data: privacyPolicyData.contactUs,
    },
  ];

  return (
    <div className="max-w-5xl mx-auto p-6 space-y-6">
      <BreadCrumb title="Privacy Policy" />

      {/* Company Information Section */}
      {/* <div className="bg-white rounded-lg md:shadow-md p-2 md:p-6 mb-6 flex flex-col gap-[15px]">
        <h2 className="text-xl font-semibold mb-4">
          {privacyPolicyData.privacyNotice.description}
        </h2>
        <ul className="list-disc list-inside">
          {privacyPolicyData.privacyNotice.points.map((point, index) => (
            <li key={index}>{point}</li>
          ))}
        </ul>
        <h1
          dangerouslySetInnerHTML={{ __html: privacyPolicyData.privacyNotice.questions }}
        />
        <h1 className="text-[32px] font-[700]">
          {privacyPolicyData.privacyNotice.summaryTitle}
        </h1>
        {privacyPolicyData.privacyNotice.summarized_data.map((item, index) => (
          <h1 key={index}>{item}</h1>
        ))}
      </div> */}

      <h2 className="text-[18px] md:text-[24px] font-[700]">
        We respect your privacy and are committed to protecting it. This privacy
        policy applies to the MoneyRateFinder, designed to provide a seamless
        remittance experience.
      </h2>

      {/* Render Accordion Sections Dynamically */}
      {sections.map((section) => (
        <AccordionSection
          key={section.key}
          title={section.title}
          isOpen={openSections[section.key]}
          onClick={() => toggleSection(section.key)}
        >
          <SectionContent data={section.data} />
        </AccordionSection>
      ))}

      <div className="mt-8 p-4 bg-gray-50 rounded-lg text-center text-gray-600 font-semibold sm:text-[18px] text-[14px] flex flex-col gap-3">
        <h2>By using moneyratefinder, you agree to this privacy policy.</h2>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
